// Small dependency-free id generator, used for log entry ids and session ids
// (avoids pulling in the `uuid` package for this one need).
export function generateId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
